import { BaseWastesForm } from "./BaseWastesForm";
import { Card } from "react-bootstrap";
import { useContext } from "react";
import { OrderContext } from "../MainForms/OrderContext";

export function LoadingWastesForm({ fillWasteMass }) {
  const { transactionType, wastesDetails, requireApplicableKpoItems, addressId } = useContext(OrderContext) || {};
  const { isLoading } = wastesDetails || {};
  return (
    <>
      {isLoading && (
        <Card className="mb-3">
          <Card.Header>Załadunek</Card.Header>
          <Card.Body>
            <BaseWastesForm
              addressId={addressId}
              wasteFieldName="wastesDetails.loading"
              requireApplicableKpoItems={requireApplicableKpoItems}
              isAddressIdRequired
              transactionType={transactionType}
              fillWasteMass={fillWasteMass} />
          </Card.Body>
        </Card>
      )}
    </>);
}

